<div class="switch">
  <mat-button-toggle-group
    [value]="showBuilder()"
    (change)="changeBlock($event)"
  >
    <mat-button-toggle [value]="true">
      <mat-icon>construction</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle [value]="false">
      <mat-icon>manage_search</mat-icon>
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
@if (showBuilder()) {
  <app-search-keyword-item
    [item]="parentItem"
    [parentItem]="parentItem"
    [allDropListsIds]="connectedDropListsIds"
    (itemDeleted)="onItemDeleted($event)"
    (updated)="updateQuery()"
    (itemDrop)="onDragDrop($event)">
  </app-search-keyword-item>
  <app-search-keyword-list
    [allDropListsIds]="connectedDropListsIds"
    [keywords]="keywords()"
  ></app-search-keyword-list>
}
@if (formGroup()) {
  <div [formGroup]="formGroup()!">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Query</mat-label>
      <textarea
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="2"
        matInput formControlName="query" placeholder="Enter PubMed query"></textarea>

      @if (formGroup()!.get('query')?.hasError('required')) {
        <mat-error>
          {{ researchSource() }} query is required.
        </mat-error>
      }
      @if (formGroup()!.get('query')?.hasError('validQuery')) {
        <mat-error>
          Invalid  {{ researchSource() }} Query.
        </mat-error>
      }
    </mat-form-field>
  </div>
} @else {
  @if (finalQuery) {
    <p>
      {{ finalQuery }}
    </p>
  } @else {
    <p>
      No query set
    </p>
  }
}

